// Generador de PDF para certificaciones
export const generateCertificatePDF = async (cert) => {
  // Si el certificado tiene un PDF real, descargarlo
  if (cert.realPDF) {
    // Usar URL específica del certificado o fallback a variable de entorno
    let pdfUrl;
    
    if (cert.id === 1) {
      // Certificado EA alojado junto al portfolio
      pdfUrl = '/documents/employment-certificate.pdf';
    } else if (cert.id === 2) {
      // Certificado SOC - usar URL del certificado o fallback
      pdfUrl = cert.pdfUrl || '/documents/certification.pdf';
    } else if (cert.pdfUrl) {
      // Cualquier otro certificado con URL
      pdfUrl = cert.pdfUrl;
    }
    
    if (pdfUrl) {
      try {
        // Crear un link temporal y hacer clic
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = cert.filename || 'certificado.pdf';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return true;
      } catch (error) {
        console.error('Error downloading PDF:', error);
        return false;
      }
    }
  }
  
  // Para otros certificados, generar HTML
  const pdfContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <style>
        body {
          font-family: 'Arial', sans-serif;
          padding: 40px;
          background: linear-gradient(135deg, #0a0712 0%, #15102a 100%);
          color: #b06bff;
        }
        .certificate {
          max-width: 800px;
          margin: 0 auto;
          background: #15102a;
          padding: 60px;
          border: 5px solid #b06bff;
          border-radius: 20px;
          box-shadow: 0 0 50px rgba(176, 107, 255, 0.5);
        }
        .header {
          text-align: center;
          margin-bottom: 40px;
        }
        .title {
          font-size: 48px;
          font-weight: bold;
          color: #b06bff;
          text-transform: uppercase;
          text-shadow: 0 0 20px rgba(176, 107, 255, 0.8);
        }
        .cert-name {
          font-size: 32px;
          margin: 30px 0;
          color: #FFFFFF;
        }
        .info {
          margin: 20px 0;
          font-size: 18px;
          line-height: 1.8;
        }
        .footer {
          margin-top: 60px;
          text-align: center;
          font-size: 14px;
          color: #888;
        }
        .seal {
          width: 100px;
          height: 100px;
          border: 3px solid #b06bff;
          border-radius: 50%;
          margin: 40px auto;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
        }
      </style>
    </head>
    <body>
      <div class="certificate">
        <div class="header">
          <div class="title">Certificado</div>
        </div>
        <div class="cert-name">${cert.name}</div>
        <div class="info">
          <strong>Emitido por:</strong> ${cert.issuer}<br>
          <strong>Fecha:</strong> ${cert.date}<br>
          <strong>Descripción:</strong> ${cert.description}
        </div>
        <div class="seal">✓</div>
        <div class="footer">
          Este es un certificado generado por el Portfolio Terminal<br>
          © ${new Date().getFullYear()} C4sh3r
        </div>
      </div>
    </body>
    </html>
  `;

  // Crear un Blob del contenido HTML
  const blob = new Blob([pdfContent], { type: 'text/html' });
  const url = URL.createObjectURL(blob);

  // Crear un link de descarga
  const link = document.createElement('a');
  link.href = url;
  link.download = `${cert.name.replace(/\s+/g, '_')}_Certificate.html`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  return true;
};
